let hostname;
if(window && window.location) {
  hostname = window.location.hostname;
}
const isDevelopment = hostname && (hostname === 'localhost' || hostname.startsWith('192.168'));

let apiUrl = '';
if (isDevelopment) {
  apiUrl = `http://localhost:8080`;
} else {
  apiUrl = `https://tc-booking.appspot.com`;
}

export { apiUrl };